import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "form-group col-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, [
  /*#__PURE__*/_createTextVNode(" Title "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "form-group col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "notes" }, [
  /*#__PURE__*/_createTextVNode(" Notes "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`animated ${_ctx.showNoteForm ? 'faster fadeInDown' : 'slow fadeOutUp'}`)
  }, [
    _createVNode(_component_FormSection, {
      "application-id": _ctx.application,
      showBackground: false
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              name: "title",
              type: "text",
              placeholder: "Enter Title",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.note.title) = $event)),
              disabled: _ctx.isReadOnly,
              maxlength: "50"
            }, null, 8 /* PROPS */, _hoisted_4), [
              [_vModelText, _ctx.note.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              name: "notes",
              type: "text",
              placeholder: "Enter Preadmission Notes",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.note.notes) = $event)),
              disabled: _ctx.isReadOnly,
              maxlength: "2000"
            }, "\r\n                        ", 8 /* PROPS */, _hoisted_7), [
              [_vModelText, _ctx.note.notes]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary mb-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeNoteForm()))
          }, "Close")
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["application-id"])
  ], 2 /* CLASS */))
}